import { isAuthorizationError } from "utils/errorUtils";

/** Which drawer the tenant streams page shows for the stream id in the URL. */
export function selectedStreamDrawer(
  selectedId: string | undefined,
  facilityId: string | null | undefined,
  error: unknown
): "none" | "denied" | "details" {
  if (!selectedId) return "none";
  if (facilityId) return "details";
  return isAuthorizationError(error) ? "denied" : "none";
}
